export default "__VITE_ASSET__DmZiDnm8__"